{% block acris_faq_list %}

    <sw-page class="acris-faq-list">
        {% block acris_faq_list_search_bar %}
            <template #search-bar>
                <sw-search-bar initialSearchType="FAQ"
                               :placeholder="$tc('acris-faq.general.placeholderSearchBar')"
                               :initialSearch="term"
                               @search="onSearch">
                </sw-search-bar>
            </template>
        {% endblock %}

        {% block acris_faq_list_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_faq_list_smart_bar_header_title %}
                    <h2>
                        {% block acris_faq_list_smart_bar_header_title_text %}
                            {{ $tc('acris-faq.list.textHeadline') }}
                        {% endblock %}

                        {% block acris_faq_list_smart_bar_header_amount %}
                            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                        ({{ total }})
                        </span>
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_list_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch @on-change="onChangeLanguage"></sw-language-switch>
            </template>
        {% endblock %}

        {% block acris_faq_list_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_faq_list_smart_bar_actions_add %}
                    <mt-button variant="primary" @click="$router.push({ name: 'acris.faq.create' })" size="default">
                        {{ $tc('acris-faq.list.buttonAdd') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_list_cardview %}
            <template #content>
                <div class="acris-faq-list__content">
                    {% block acris_faq_list_content %}
                        <sw-entity-listing class="acris-faq-list-grid"
                                           v-if="items && total > 0"
                                           :items="items"
                                           :repository="entityRepository"
                                           detailRoute="acris.faq.detail"
                                           :showSeleciton="true"
                                           :isLoading="isLoading"
                                           :columns="columns">

                            {% block acris_faq_list_grid_columns_image_position %}
                                <template #column-imagePosition="{ item, isInlineEdit }">
                                    {% block acris_faq_list_grid_columns_image_position_content %}
                                        <template v-if="!isInlineEdit">
                                            <router-link :title="$tc('acris-faq.list.contextMenuEdit')"
                                                         :to="{ name: 'acris.faq.detail', params: { id: item.id } }">
                                                {% block acris_faq_list_columns_status_link %}
                                                    <template
                                                        v-if="item.imagePosition == 'right'">{{ $tc('acris-faq.list.fieldSelectOptionRight') }}</template>
                                                    <template
                                                        v-if="item.imagePosition == 'left'">{{ $tc('acris-faq.list.fieldSelectOptionLeft') }}</template>
                                                    <template
                                                        v-if="item.imagePosition == 'top'">{{ $tc('acris-faq.list.fieldSelectOptionTop') }}</template>
                                                    <template
                                                        v-if="item.imagePosition == 'bottom'">{{ $tc('acris-faq.list.fieldSelectOptionBottom') }}</template>
                                                {% endblock %}
                                            </router-link>
                                        </template>
                                    {% endblock %}
                                </template>
                            {% endblock %}

                            {% block acris_faq_list_grid_columns_description %}
                                <template #column-description="{ item, isInlineEdit }"
                                          class="sw-event-action-list-expand-labels">
                                    {{ getCleanText(item.description) }}
                                </template>
                            {% endblock %}

                            {% block acris_faq_list_grid_columns_groups %}
                                <template #column-groups="{ item }">
                                    <sw-label
                                            v-if="item.groups.length > 0"
                                            v-for="group in item.groups"
                                            appearance="default"
                                            size="default">
                                        {{ group.translated.name || group.name }}
                                    </sw-label>
                                    <div v-else></div>
                                </template>
                            {% endblock %}

                            {% block acris_faq_list_list_grid_columns_actions %}
                                <template #more-actions="{ item }">
                                    {% block acris_faq_list_list_grid_columns_actions_duplicate %}
                                        <sw-context-menu-item
                                                @click="onDuplicate(item)">
                                            {{ $tc('acris-faq.detail.contextMenuDuplicate') }}
                                        </sw-context-menu-item>
                                    {% endblock %}
                                </template>
                            {% endblock %}

                            <template #pagination>
                                {% block sw_order_list_grid_pagination %}
                                    <sw-pagination :page="page"
                                                   :limit="limit"
                                                   :total="total"
                                                   :total-visible="7"
                                                   @page-change="onPageChange">
                                    </sw-pagination>
                                {% endblock %}
                            </template>

                        </sw-entity-listing>
                    {% endblock %}

                    {% block acris_faq_list_empty_state %}
                        <sw-empty-state v-if="!isLoading && total <= 0"
                                        :title="$tc('acris-faq.list.contentEmpty')"></sw-empty-state>
                    {% endblock %}

                </div>
            </template>
        {% endblock %}

        {% block acris_faq_list_sidebar %}
            <template #sidebar>
                <sw-sidebar class="acris-faq-list__sidebar">
                    {% block acris_faq_list_sidebar_item %}
                        <sw-sidebar-item
                            icon="regular-undo"
                            :title="$tc('acris-faq.list.titleSidebarItemRefresh')"
                            @click="onRefresh">
                        </sw-sidebar-item>
                    {% endblock %}

                    {% block acris_faq_list_sidebar_item_filter %}
                        <sw-sidebar-filter-panel
                                entity="acris_faq"
                                :store-key="storeKey"
                                :filters="listFilters"
                                :defaults="defaultFilters"
                                :active-filter-number="activeFilterNumber"
                                @criteria-changed="updateCriteria"
                        />
                    {% endblock %}
                </sw-sidebar>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
